import { createApi } from "@reduxjs/toolkit/query/react";
import { authBaseQuery } from "./auth/authBaseQuery";
import { ENDPOINTS_QAS, URL_QAS } from "../../constants/api_endpoints";
import { IDeleteQuestionsListProps, IGetQuestionsListProps, IResponseQuestionsList } from "../../types/qas/qasQuestionTypes";
import { IResponse } from "../../types/statusTypes";

export const qasApi = createApi({
	reducerPath: "qasApi",
	baseQuery: authBaseQuery,
	tagTypes: ["Questions"],
	endpoints: (builder) => ({
		getQuestionsList: builder.query<IResponseQuestionsList, IGetQuestionsListProps>({
			query: (params) => {
				// Создаем новый объект без пустых полей
				const filteredParams = Object.fromEntries(
					Object.entries(params || {})
						.filter(([key, value]) => value !== undefined && value !== null && value !== "" && key !== "__dataset")
						.map((el) => [el[0], el[1] === "-" ? "" : el[1]])
				);

				return {
					url: `${URL_QAS}/${ENDPOINTS_QAS.QUESTION_LIST}`,
					params: filteredParams,
				};
			},
			providesTags: ["Questions"],
		}),
		deleteQuestionsList: builder.mutation<IResponse, IDeleteQuestionsListProps>({
			query: ({ questionsIdList, type }) => ({
				url: `${URL_QAS}/${ENDPOINTS_QAS.QUESTION_LIST_DELETE}`,
				method: "POST",
				body: {
					questions: JSON.stringify(questionsIdList),
					type,
				},
			}),
			invalidatesTags: ["Questions"], // Aвтоматически обновит кэш для запросов с тегом 'Questions'
		}),
		// Другие эндпоинты
	}),
});

export const { useGetQuestionsListQuery, useDeleteQuestionsListMutation } = qasApi;
